import { BROADCAST_SET_SCENE_LAYERS } from 'actions/Types';

export default sceneLayers => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_SCENE_LAYERS,
      payload: sceneLayers
    };

    dispatch(action);
  };
};
